import { render, staticRenderFns } from "./Competitions.vue?vue&type=template&id=7908a62b&scoped=true&lang=html&"
import script from "./Competitions.vue?vue&type=script&lang=js&"
export * from "./Competitions.vue?vue&type=script&lang=js&"
import style0 from "./Competitions.vue?vue&type=style&index=0&id=7908a62b&lang=scss&scoped=true&"
import style1 from "./Competitions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7908a62b",
  null
  
)

export default component.exports